/*
 * @Author: liuhu liuhu@dreamdt.cn
 * @Date: 2023-06-19 11:13:08
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-08-29 14:42:42
 * @Description: 给series中为line的类型添加下划线设置方式
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
// 折线增加markLine逻辑
export default {
  // markline控制参数
  props: {
    isLineAndMarkLine: {
      type: Boolean,
      default: false
    },
    lineAndMarkLineColor: {
      type: Array,
      default() {
        return [];
      },
    },
    lineAndMarkLineInterval: {
      type: Number,
      default: 0
    },
  },
  computed: {
    lineAndMarkLineOptions() {
      return {
        symbol: 'none',
        splitNum: this.lineAndMarkLineInterval,
        colors: this.lineAndMarkLineColor, // 颜色控制
        lineStyle: {
          width: 1, // 线宽度设置
        },
        data: []
      }
    }
  },
  watch: {
    lineAndMarkLineOptions() {
      this.$nextTick(() => {
        if (this.isDesign) {
          this.reset();
        }
      });
    },
    isLineAndMarkLine: {
      handler(v) {
        if (this.chart) {
          this.reset();
        }
      },
    },
  },
  methods: {
    addMarkLineToLine(chart = this.chart) {
      if (!chart?.xAxis) {
        return;
      }
      const series = chart.series;
      if (this.isLineAndMarkLine) {
        if (chart?.xAxis[0]?.type === 'category' && chart?.yAxis[0]?.type === 'category') {
          return;
        }
        const isXCategory = chart.xAxis[0].type === 'category';
        // 只用于线计数，用于找到对应的标记线颜色
        let lineIdx = 0;
        series.forEach((it) => {
          if (it.type === 'line') {
            it = this.getMarkLineToLineSeries(it, isXCategory, lineIdx);
            lineIdx++;
          }
        });
      } else {
        // 删除逻辑
        series.forEach((it) => {
          if (it.type === 'line') {
            it = this.deleteMarkLineToLineSeries(it);
          }
        });
      }
    },
    /**
     * @description: 生成构造下划线需要配置
     * @param {Object} params
     * @return {Object} 返回新生成的series
     */
    getMarkLineToLineSeries(params, isXCategory, colorIdx) {
      const { markLine, data = [], itemStyle } = params;
      let common = this.lineAndMarkLineOptions;
      // 间隔数
      const splitNum = common.splitNum || 0;
      let startInterVal = 0;
      const markData = [];
      data.forEach((item, idx) => {
        const value = item?.value ? item.value : item;
        if (startInterVal !== idx) {
          return;
        }
        if (isXCategory) {
          markData.push([{
            name: '',
            coord: [idx, 0],
            lineStyle: {
              color: common.colors[colorIdx] || itemStyle.color
            }
          }, {
            coord: [idx, value]
          }]);
        } else {
          markData.push([{
            name: '',
            coord: [0, idx],
            lineStyle: {
              color: common.colors[colorIdx] || itemStyle.color
            }
          }, {
            coord: [value, idx]
          }]);
        }
        startInterVal += splitNum + 1;
      })
      let targetLineData = []
      // 兼容通过设置目标线伪代码的内容
      if (markLine) {
        // 过滤出设置目标线的伪代码数据
        targetLineData = markLine.data.filter(item => item.targetLine)
      }
      params.markLine = {
        ...common,
        data: [...targetLineData, ...markData]
      }
      return params
    },
    //删除折线图的标线
    deleteMarkLineToLineSeries(params) {
      const { markLine } = params;
      if (markLine) {
        markLine.data = markLine.data.filter(item=>item.targetLine)
        if(markLine.data.length){
          params.markLine = markLine
        }else {
          Reflect.deleteProperty(params, 'markLine');
        }
      }
      return params;
    }
  }
}